import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../pages/Index'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {
    return window.location.reload();
  });
};
Vue.use(VueRouter)

const routes = [
  {
    path: "/main",
    name: "메인",
    component: Index,
    meta: { requireAuth: false },
  },
  { path: "/", redirect: "/main" },
  { path: "*", redirect: "/main" },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router
